export default __webpack_public_path__ + "static/eu1-464d4fe9f69215782f639bcaba966cff.png";